import React, { useState } from 'react';
import './subscription.css';  // Import the CSS
import { baseUrlUser } from './common';

const SubscriptionDetails = () => {
  const [product, setProduct] = useState('LensLite');
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem('treziAccessToken');

  const fetchSubscriptions = async () => {
    setLoading(true);
    try {
      const url = `${baseUrlUser}users/subscriptions/com/${encodeURIComponent(product)}`;
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Failed to fetch subscriptions. Status: ${response.status}, Response: ${text}`);
      }

      const data = await response.json();
      setSubscriptions(data || []);
    } catch (error) {
      console.error('Error fetching subscriptions:', error.message);
      setSubscriptions([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="subscription-page">
      <div className="subscription-container">
        <h2 className="subscription-title">Subscription Details</h2>
        <div className="subscription-filters">
          <label className="subscription-label" htmlFor="product">Product:</label>
          <input
            className="subscription-input"
            type="text"
            id="product"
            value={product}
            onChange={(e) => setProduct(e.target.value)}
          />
          <button className="subscription-button" onClick={fetchSubscriptions}>
            Fetch Subscriptions
          </button>
        </div>
        {loading ? (
          <p className="subscription-loading">Loading subscriptions...</p>
        ) : subscriptions.length > 0 ? (
          <ul className="subscription-list">
            {subscriptions.map((sub) => (
              <li className="subscription-item" key={sub.subscriptionId}>
                <strong>Subscription ID:</strong> {sub.subscriptionId} |{' '}
                <strong>Client:</strong> {sub.clientId} |{' '}
                <strong>Plan:</strong> {sub.plan} |{' '}
                <strong>Start:</strong> {new Date(sub.startDate).toLocaleDateString()} |{' '}
                <strong>End:</strong> {new Date(sub.endDate).toLocaleDateString()}
              </li>
            ))}
          </ul>
        ) : (
          <p className="subscription-status">
            No subscriptions found for <strong>{product}</strong>.
          </p>
        )}
      </div>
    </div>
  );
};

export default SubscriptionDetails;
